import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CustomerEnrollRoutingModule } from './customer-enroll-routing.module';
import { ChangePhoneNumberComponent } from './change-phone-number/change-phone-number.component';
import { CustomerEnrollService } from './customer-enroll.service';
import { CustomerEnrollWizardComponent } from './customer-enroll-wizard/customer-enroll-wizard.component';
import { MobilePhoneInfo } from './customer-enroll-wizard/customer-enroll-wizard.component';
import { DateOfBirthInfo } from './customer-enroll-wizard/customer-enroll-wizard.component';
import { MobilePhoneInfo as  MobilePhoneInfoV2} from './customer-enroll-wizard-v2/customer-enroll-wizard-v2.component';
import { DateOfBirthInfo as DateOfBirthInfoV2} from './customer-enroll-wizard-v2/customer-enroll-wizard-v2.component';
import { InfoDialog, SaveDataOnSessionExpire } from './customer-enroll-wizard-v2/customer-enroll-wizard-v2.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import {  MatButtonModule,
          MatCheckboxModule,
          MatDatepickerModule,
          MatDialogModule,
          MatIconModule,
          MatInputModule,
          MatNativeDateModule,
          MatSelectModule,
          MatSidenavModule,
          MatToolbarModule,
          MatSlideToggleModule,
          MatProgressSpinnerModule,
          MatTooltipModule} from '@angular/material';
import { FirstPaymentOptionComponent } from './first-payment-option/first-payment-option.component';
import { SetupAutopayComponent } from './setup-autopay/setup-autopay.component';
import { CustomerEnrollWizardV2Component } from './customer-enroll-wizard-v2/customer-enroll-wizard-v2.component';
import { CongratsComponent } from './congrats/congrats.component';
import { TextMaskModule } from 'angular2-text-mask';
import { EsiIdFlaggedComponent } from 'app/esiid-flagged/esiid-flagged.component';
import {OtpVerifyComponent} from '../auth/otp-verify/otp-verify.component';
import {AuthModule} from '../auth/auth.module';
import {EmailOtpVerifyComponent} from '../auth/email-otp-verify/email-otp-verify.component';
import {EmailValidationComponent} from '../email/email-validation.component';
import {PaymentusModule} from '../payment/paymentus/paymentus.module';

@NgModule({
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
    imports: [
        CommonModule,
        CustomerEnrollRoutingModule,
        FormsModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        MatButtonModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatIconModule,
        MatInputModule,
        MatNativeDateModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MatSlideToggleModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        TextMaskModule,
        AuthModule,
        PaymentusModule
    ],

  providers: [CustomerEnrollService, DatePipe],
  declarations: [
    ChangePhoneNumberComponent,
    CustomerEnrollWizardComponent,
    MobilePhoneInfo,
    DateOfBirthInfo,
    MobilePhoneInfoV2,
    DateOfBirthInfoV2,
    InfoDialog,
    SaveDataOnSessionExpire,
    FirstPaymentOptionComponent,
    SetupAutopayComponent,
    CustomerEnrollWizardV2Component,
    CongratsComponent,
    EsiIdFlaggedComponent
  ],
  exports: [
  ],
  bootstrap: [MobilePhoneInfo, DateOfBirthInfo, MobilePhoneInfoV2, DateOfBirthInfoV2, InfoDialog, SaveDataOnSessionExpire]
})
export class CustomerEnrollModule { }



// WEBPACK FOOTER //
// ./src/app/customer-enroll/customer-enroll.module.ts